require('/ui/components/taskflow/leftNav/leftNav.module.scss.module.css');

export const container = "_container_125zc_1";
export const smallViewportSupport = "_small-viewport-support_125zc_1";
export const cardWrapper = "_card-wrapper_125zc_1";
export const sectionHeaderContainer = "_section-header-container_125zc_1";
export const cardContainer = "_card-container_125zc_1";
export const cardBodyContainer = "_card-body-container_125zc_1";
export const cardIcon = "_card-icon_125zc_1";
export const cardBodyPrefix = "_card-body-prefix_125zc_1";
export const cardBody = "_card-body_125zc_1";
export const partition = "_partition_125zc_1";
export const partitionVisible = "_partition-visible_125zc_1";
